/** Chat alerts stay on the envelope icon — exclude from bell / Notifications page. */
export function isMessageNotification(item: { name?: string }): boolean {
  return (item.name || "").trim().toLowerCase() === "new message";
}

/** Where connection / event / admin notifications should go on click. */
export function resolveNotificationPath(notification: {
  id: number;
  name?: string;
  description?: string;
}): string {
  const name = (notification.name || "").trim().toLowerCase();
  const description = (notification.description || "").trim().toLowerCase();

  if (
    description.includes("connection request") ||
    description.includes("accepted your connection") ||
    description.includes("rejected your connection")
  ) {
    return "/connections";
  }

  if (name === "new event") {
    return "/event-booking";
  }

  return `/notifications?id=${notification.id}`;
}

export function isNavigableSystemNotification(notification: {
  name?: string;
  description?: string;
}): boolean {
  const path = resolveNotificationPath({ ...notification, id: 0 });
  return path === "/connections" || path === "/event-booking";
}
